"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _Sq1Icon = createIcon({
  displayName: "_Sq1Icon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="M50 50v129.99l177.56 47.57L180 50zm154.83 0L250 218.56 295.17 50zm115.18 0-47.57 177.56L450 180V50zM50 204.83v90.34L218.56 250zm400 0L281.44 250 450 295.17zm-222.44 67.6L50 320.02V450h129.99zm44.88 0L320 450H450V320.01zm-22.44 9L204.83 450h90.34z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _Sq1Icon;
